jQuery(document).ready(function($) {


  $('img[src="//drinkkojuice.com/cdn/shop/files/1_The_Original.jpg?v=1726098299&width=3000"]').attr('alt', 'fresh ko juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/5_Strawberry_Cane.jpg?v=1726098650&width=3000"]').attr('alt', 'strawberry cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/11_Watermelon_Cane.jpg?v=1726098653&width=3000"]').attr('alt', 'watermelon cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/2_The_Classic.jpg?v=1726098672&width=3000"]').attr('alt', 'ko juice classic');
$('img[src="//drinkkojuice.com/cdn/shop/files/3_Lemon_Aid.jpg?v=1726098676&width=3000"]').attr('alt', 'Lemon ko juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/4_Apple_Cane.jpg?v=1726098684&width=3000"]').attr('alt', 'apple cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/6_Koko_Cane.jpg?v=1726098694&width=3000"]').attr('alt', 'koko cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/7_Ginger_Cane.jpg?v=1726098700&width=3000"]').attr('alt', 'ginger cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/8_Hydrator.jpg?v=1726098704&width=3000"]').attr('alt', 'orange cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/9_Ko_Passion.jpg?v=1726098709&width=3000"]').attr('alt', 'ko passion juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/10_Ko_Tropical.jpg?v=1726098711&width=3000"]').attr('alt', 'ko tropical juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/12_Mango_Cane.jpg?v=1726098741&width=3000"]').attr('alt', 'mango cane juice');
$('img[src="//drinkkojuice.com/cdn/shop/files/Snapinsta.app_378843917_17947403270693645_7342138871507327182_n_1080.jpg?v=1726128466&width=1080"]').attr('alt', 'happy customer sharing photo on social media');
$('img[src="//drinkkojuice.com/cdn/shop/files/Snapinsta.app_342391458_791659739196032_1445157676162294667_n_1080.jpg?v=1726129234&width=1080"]').attr('alt', 'happy customer sharing photo on social media');
$('img[src="//drinkkojuice.com/cdn/shop/files/Snapinsta.app_333629813_946083263394702_4905428311738634927_n_1080.jpg?v=1726129321&width=1080"]').attr('alt', 'happy women customer sharing photo on social media');
$('img[src="//drinkkojuice.com/cdn/shop/files/55_eef56753-7939-46c1-9f0c-43f2c73a91ee.png?v=1726130160&width=1080"]').attr('alt', 'door dash logo');
$('img[src="//drinkkojuice.com/cdn/shop/files/55.png?v=1726130077&width=1080"]').attr('alt', 'uber eats logo');
$('img[src="//drinkkojuice.com/cdn/shop/files/Untitled-4.png?v=1726129991&width=1080"]').attr('alt', 'grubhub logo');
  $('img[src="//drinkkojuice.com/cdn/shop/files/transnsnsns.png?v=1726126859&width=914"]').attr('alt', 'Ko Juice logo');
  
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}
$("div.section.section-blends a[href='/pages/contact']").each(function() {
        var link = $(this);
        var linkText = link.text();
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });
$("on-sale-badge.badge.badge--on-sale ").each(function() {
        var link = $(this);
        var linkText = link.text();
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });
  

});